import React from 'react';
import Reflux from 'reflux';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import ConfirmActions from 'flux/actions/ConfirmActions';
import NewGlobalElementModalActions from 'flux/actions/NewGlobalElementModalActions';

import PureRenderMixin from 'react-pure-render/mixin';

import PopoverStore from 'shared/flux/stores/PopoverStore';
import UserSessionStore from 'flux/stores/UserSessionStore';

import PopoverActions from 'shared/flux/actions/PopoverActions';

import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import { Map, OrderedMap } from 'immutable';
import RowMenuColorsMixin from 'main/components/show/cuesheet/itemCell/rowMenuColorsMixin.jsx';
import role from 'shared/lib/role';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import MessageConstants from 'shared/constants/Messages';
import { isGlobalElementManager } from 'main/components/show/cuesheet/cuesheetViewHelper';
import { hasGlobalElementsFullAccess } from 'shared/lib/permission';
import TeamViewStore from 'flux/stores/TeamViewStore';

import { isMac } from 'shared/lib/platformCheck';
import KeyModifierConstants from 'shared/constants/KeyModifierConstants.jsx';

export default React.createClass({
  displayName: 'ItemEditMenu',

  propTypes: {
    item: React.PropTypes.any.isRequired,
    rowIndex: React.PropTypes.number.isRequired,
    showTrackingOption: React.PropTypes.bool,
    showLockOption: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      showTrackingOption: true,
      showLockOption: true,
    };
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    Reflux.connect(TeamViewStore, 'team'),
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    Reflux.connectFilter(CuesheetStore, 'pasteMode', (state) =>
      state.get('pasteMode'),
    ),
    Reflux.connectFilter(CuesheetStore, 'rowSelectionMode', (state) =>
      state.get('rowSelectionMode'),
    ),
    Reflux.connect(UserSessionStore, 'user'),
    PureRenderMixin,
    RowMenuColorsMixin,
  ],

  render() {
    const id = this.props.item.get('_id');
    const showRowMenu = this.state.popoverVisibility.get(id);

    return (
      <PopoverMenu
        className="cs-row-menu"
        config={this._getConfigData()}
        show={showRowMenu}
      />
    );
  },

  _getConfigData() {
    const { teamId, eventId } = this.context.router.state.params;
    const hasEventAdmin = role.hasEventAdminRole(
      this.state.user,
      teamId,
      eventId,
    );

    if (this.state.rowSelectionMode && hasEventAdmin) {
      return this._getSelectionConfig();
    }

    return this._getSingleRowConfig();
  },

  /**
   * Get the menu for when we are in 'single row' mode
   */
  _getSingleRowConfig() {
    /**
     * An item in the items field can have a "type" of: link, divider, custom
     *  * link - standard dropdown link
     *  * divider - represents a divider line
     *  * custom - respresents a custom component
     */
    const { team } = this.state;

    const { item, disableReordering } = this.props;
    const titleRow = item.get('titleView');
    const id = item.get('_id');
    const itemLocked = item.get('locked');

    const { teamId, eventId } = this.context.router.state.params;
    const hasEventAdmin = role.hasEventAdminRole(
      this.state.user,
      teamId,
      eventId,
    );
    const hasEventShowCaller = role.hasEventShowCallerRole(
      this.state.user,
      eventId,
    );
    const hasTeamAdmin = role.hasTeamAdminRole(this.state.user, teamId);
    const hasGlobalElementsPermission = hasGlobalElementsFullAccess(
      team.get('permissions'),
    );

    return Map({
      id,
      icon: 'gear row-menu-gear',
      placement: 'right',
      onClick: () => PopoverActions.show(id),
      onHide: () => PopoverActions.hide(id),
      items: OrderedMap({
        globalHighlight: Map({
          hidden: !hasEventAdmin,
          content: <span>{this.getGlobalHighlightsNode(id)}</span>,
        }),
        personalHighlight: Map({
          hidden: isGlobalElementManager(),
          content: <span>{this.getPersonalHighlightsNode(id)}</span>,
        }),
        addItemRow: Map({
          hidden: !hasEventAdmin,
          content: (
            <span>
              Add Item Row Below
              {this._getKeyModifier('addRowBelow')}
            </span>
          ),
          onClick: () => this._handleAddItemRowClick(),
        }),
        addTitleRow: Map({
          hidden: !hasEventAdmin,
          content: (
            <span>
              Add Title Row Above
              {this._getKeyModifier('addTitleRowAbove')}
            </span>
          ),
          onClick: () => this._handleAddTitleRowClick(),
        }),
        convertTitleRow: Map({
          hidden: titleRow || !hasEventAdmin,
          content: (
            <span>
              Convert to Title Row
              {this._getKeyModifier('convertTitleRowItemRow')}
            </span>
          ),
          onClick: () => this._handleConvertTitleRowClick(),
        }),
        convertStandardRow: Map({
          hidden: !titleRow || !hasEventAdmin,
          content: (
            <span>
              Convert to Item Row
              {this._getKeyModifier('convertTitleRowItemRow')}
            </span>
          ),
          onClick: () => this._handleConvertStandardRowClick(),
        }),
        lockRow: Map({
          hidden: itemLocked || !hasEventAdmin || !this.props.showLockOption,
          content: (
            <span>
              Lock Row
              {this._getKeyModifier('lockRow')}
            </span>
          ),
          onClick: () => this._handleToggleRowLockClick(),
        }),
        unlockRow: Map({
          hidden: !itemLocked || !hasEventAdmin || !this.props.showLockOption,
          content: (
            <span>
              Unlock Row
              {this._getKeyModifier('lockRow')}
            </span>
          ),
          onClick: () => this._handleToggleRowLockClick(),
        }),
        duplicateItemRow: Map({
          hidden: !hasEventAdmin,
          content: (
            <span>
              Duplicate Item Row
              {this._getKeyModifier('duplicateRow')}
            </span>
          ),
          onClick: () => this._handleDuplicateItemRowClick(),
        }),
        copyItemRow: Map({
          hidden: !hasEventAdmin || disableReordering,
          content: (
            <span>
              Copy Item Row
              {this._getKeyModifier('copyRow')}
            </span>
          ),
          onClick: () => this._handleCopyItemRowClick(),
        }),
        cutItemRow: Map({
          hidden: !hasEventAdmin || disableReordering,
          content: (
            <span>
              Cut Item Row
              {this._getKeyModifier('cutRow')}
            </span>
          ),
          onClick: () => this._handleCutItemRowClick(),
        }),
        deleteItemRow: Map({
          hidden: !hasEventAdmin,
          divider: true,
          content: (
            <span>
              Delete Item Row
              {this._getKeyModifier('deleteRow')}
            </span>
          ),
          onClick: () => this._handleDeleteItemRowClick(),
        }),
        createGlobalElement: Map({
          hidden:
            !hasTeamAdmin ||
            !hasGlobalElementsPermission ||
            isGlobalElementManager(),
          content: (
            <span>
              Save As New Global Element
              {this._getKeyModifier('saveAsNewGE')}
            </span>
          ),
          divider: true,
          onClick: () => this._handleSaveAsNewGlobalElementClick(),
        }),
        trackItem: Map({
          hidden: !hasEventShowCaller || !this.props.showTrackingOption,
          content: (
            <WithTooltip placement="right" tip={TooltipConstants.CSTrackItem}>
              <p>Track Item{this._getKeyModifier('trackRow')}</p>
            </WithTooltip>
          ),
          onClick: () => this._handleTrackItemRowClick(),
        }),
        pasteItemRowAbove: Map({
          hidden: true,
          content: (
            <span>
              Paste Row Above
              {this._getKeyModifier('pasteRow')}
            </span>
          ),
          onClick: () => this._handlePasteItemRowAboveClick(),
        }),
        pasteItemRowBelow: Map({
          hidden: !this.state.pasteMode || !hasEventAdmin || disableReordering,
          content: (
            <span>
              Paste Row
              {this._getKeyModifier('pasteRow')}
            </span>
          ),
          onClick: () => this._handlePasteItemRowBelowClick(),
        }),
      }).filter((item) => item.get('hidden') !== true),
    });
  },

  _getKeyModifier(type) {
    const command = isMac()
      ? KeyModifierConstants.macKeys[type]
      : KeyModifierConstants.windowsKeys[type];

    return <span className="shortcut-key-modifier">{command}</span>;
  },

  /**
   * Get the menu for when we are in 'row selection mode'
   */
  _getSelectionConfig() {
    const { user, team } = this.state;
    const { item, disableReordering } = this.props;
    const id = item.get('_id');

    const { teamId, eventId } = this.context.router.state.params;

    const hasTeamAdmin = role.hasTeamAdminRole(user, teamId);
    const hasEventAdmin = role.hasEventAdminRole(user, teamId, eventId);
    const hasGlobalElementsPermission = hasGlobalElementsFullAccess(
      team.get('permissions'),
    );

    return Map({
      id,
      icon: 'gear row-menu-gear',
      placement: 'right',
      onClick: () => PopoverActions.show(id),
      onHide: () => PopoverActions.hide(id),
      items: OrderedMap({
        title: Map({
          content: <h4>Bulk Edits</h4>,
        }),
        globalHighlight: Map({
          hidden: !hasEventAdmin,
          content: <span>{this.getGlobalHighlightsNode(id)}</span>,
        }),
        personalHighlight: Map({
          content: <span>{this.getPersonalHighlightsNode(id)}</span>,
        }),
        //'convertTitleRows': Map({
        //  content: 'Convert to Title Rows',
        //  onClick: () => {}
        //}),
        //'convertItemRows': Map({
        //  content: 'Convert to Item Rows',
        //  onClick: () => {}
        //}),
        //'duplicateItemRows': Map({
        //  content: 'Duplicate Item Rows',
        //  onClick: () => this._handleDuplicateSelectionClick()
        //}),
        copyItemRows: Map({
          hidden: disableReordering,
          content: (
            <span>
              Copy Rows
              {this._getKeyModifier('copyRow')}
            </span>
          ),
          onClick: () => this._handleCopySelectionClick(),
        }),
        cutItemRows: Map({
          hidden: disableReordering,
          content: (
            <span>
              Cut Rows
              {this._getKeyModifier('cutRow')}
            </span>
          ),
          onClick: () => this._handleCutSelectionClick(),
        }),
        deleteItemRows: Map({
          divider: true,
          content: (
            <span>
              Delete Rows
              {this._getKeyModifier('deleteRow')}
            </span>
          ),
          onClick: () => this._handleDeleteSelectionClick(),
        }),
        pasteItemRowBelow: Map({
          hidden: !this.state.pasteMode || disableReordering,
          content: (
            <span>
              Paste Rows
              {this._getKeyModifier('pasteRow')}
            </span>
          ),
          onClick: () => this._handlePasteSelectionBelowClick(),
        }),
        createGlobalElement: Map({
          hidden: !hasTeamAdmin || !hasGlobalElementsPermission,
          divider: true,
          content: (
            <span>
              Save As New Global Elements
              {this._getKeyModifier('createGlobalElement')}
            </span>
          ),
          onClick: () => this._handleSaveSelectionNewGlobalElementClick(),
        }),
        clearSelection: Map({
          content: 'Deselect All',
          onClick: () => this._handleClearSelectionClick(),
        }),
      }).filter((item) => item.get('hidden') !== true),
    });
  },

  _handleSaveSelectionNewGlobalElementClick() {
    CuesheetRowActions.saveSelectionAsNewGlobalElements();
  },

  _handleSaveAsNewGlobalElementClick() {
    NewGlobalElementModalActions.populate([this.props.rowIndex]);
  },

  _handleToggleRowLockClick() {
    CuesheetRowActions.toggleRowLock(this.props.rowIndex);
  },

  _handleClearSelectionClick() {
    CuesheetRowActions.clearRowSelection();
  },

  _handlePasteItemRowAboveClick() {
    CuesheetRowActions.pasteBufferAbove(this.props.rowIndex);
  },

  _handlePasteItemRowBelowClick() {
    CuesheetRowActions.pasteBufferBelow(this.props.rowIndex);
  },

  _handleAddItemRowClick() {
    CuesheetRowActions.addItemRowBelow(this.props.rowIndex);
  },

  _handleAddTitleRowClick() {
    CuesheetRowActions.addTitleRowAbove(this.props.rowIndex);
  },

  _handleConvertTitleRowClick() {
    CuesheetRowActions.convertToTitleRow(this.props.rowIndex);
  },

  _handleConvertStandardRowClick() {
    CuesheetRowActions.convertToStandardRow(this.props.rowIndex);
  },

  _handleDuplicateItemRowClick() {
    CuesheetRowActions.duplicateItemRow(this.props.rowIndex);
  },

  _handleDuplicateSelectionClick() {
    ConfirmActions.prompt(MessageConstants.bulkWarning, () =>
      CuesheetRowActions.duplicateSelection(this.props.rowIndex),
    );
  },

  _handleCopyItemRowClick() {
    CuesheetRowActions.addRowToPasteBuffer(this.props.rowIndex);
  },

  _handleCopySelectionClick() {
    CuesheetRowActions.addSelectionToPasteBuffer();
  },

  handleSaveSelectionNewGlobalElementClick() {
    CuesheetRowActions.saveSelectionAsNewGlobalElements();
  },

  _handlePasteSelectionBelowClick() {
    ConfirmActions.prompt(MessageConstants.bulkWarning, () =>
      CuesheetRowActions.pasteBufferBelow(this.props.rowIndex),
    );
  },

  _handleCutItemRowClick() {
    ConfirmActions.prompt(
      MessageConstants.cutRowTransferActivityFeedWarning,
      () => CuesheetRowActions.addRowToCutBuffer(this.props.rowIndex),
    );
  },

  _handleCutSelectionClick() {
    ConfirmActions.prompt(
      MessageConstants.cutRowTransferActivityFeedWarning,
      () => CuesheetRowActions.addSelectionToCutBuffer(),
    );
  },

  _handleDeleteItemRowClick() {
    CuesheetRowActions.handleDeleteRowWithConfirmation(this.props.rowIndex);
  },

  _handleDeleteSelectionClick() {
    CuesheetRowActions.deleteSelectedRowsWithConfirmation();
  },

  _handleTrackItemRowClick() {
    CuesheetRowActions.trackRow(this.props.rowIndex);
  },
});
